import {FC, useEffect, useReducer} from 'react';
import {DefaultGrid} from '../../../../components/grids/default/defaultGrid';
import {PluginWrapper} from '../../../../components/plugins';
import {Spinner} from '../../../../components/spiner/Spinner';
import {GosContractDataProvider} from '../../../../Services/DataProviders/GosContractDataProvider';
import useGridFilter from '../../../../system/hooks/useGridFilter';
import {useAppContext} from '../../../../system/providers/appContextProvider';
import { initialState, reducer } from '../state/GosContractGoodsGrid/reducer';

interface IExtendedGridProps extends IGridProps {
    idGosContractGlobal: string;
    idGoodsGlobal: string
}

export const GosContractGoodsGrid: FC<IExtendedGridProps> = (props) => {
  const appContext = useAppContext();
  const gosContractDP = new GosContractDataProvider(appContext.coreApiService);

  const [state, dispatch] = useReducer(reducer, initialState);

  const goodsGridFilter: IGridFilter = {
    numberPerPage: 15,
    pageNumber: 1,
    columnFilters: [
        {
            name: "idGoodsGlobal",
            operator: 'Eq',
            value: props.idGoodsGlobal
        }
    ],
};

  const [gridFilter, dispatchGridFilter] = useGridFilter(goodsGridFilter);

  const loadData = (filter = gridFilter, callback?) => {
    gosContractDP.getItemsView(props.idGosContractGlobal, filter, (entity, totalCount) => {
      dispatch({type: 'setData', payload: {data: entity, totalCount: totalCount}});
      callback?.(entity, totalCount);
    });
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <PluginWrapper>
      {state.isSubmitting ? (
        <Spinner />
      ) : (
        <DefaultGrid
          showQuantity
          separator
          singleDirectory
          gridId={props.gridId}
          data={state.data}
          totalCount={state.totalCount}
          filter={gridFilter}
          getView={(gridFilter, callback) => {
            loadData(gridFilter, callback);
          }}
          plugin={props.plugin}
          selectedItem={state.selectedItem}
          onDoubleClick={(row) => props.onDoubleClick?.(row)}
          onSelect={(row) => {
            dispatch({type: 'changeSelectedItem', payload: row});
            props.onSelect?.(row);
          }}
          onSort={(i) => dispatchGridFilter({type: 'sort', payload: i.propertyName})}
          onFilterDelete={(i) => dispatchGridFilter({type: 'deleteColumnFilter', payload: i.propertyName})}
          onPageNumberChange={(n) => dispatchGridFilter({type: 'changePageNumber', payload: {pageNumber: n}})}
          onNumberPerPageChange={(n) =>
            dispatchGridFilter({type: 'changeNumberPerPage', payload: {numberPerPage: n}})
          }
        />
      )}
    </PluginWrapper>
  );
};
